import script from "./PhoneConfirmBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneConfirmBlock.vue?vue&type=script&setup=true&lang=js"

export default script